import type { FC } from 'react';
import styled from 'styled-components';

import type { JobTeaserWithHighlightsAndSummaryFragment } from '@xing-com/crate-jobs-graphql';
import {
  scale110,
  spaceL,
  spaceS,
  spaceXS,
  xdlColorTextSecondary,
} from '@xing-com/tokens';

type SummaryProps = NonNullable<
  JobTeaserWithHighlightsAndSummaryFragment['summary']
>;

export const Summary: FC<SummaryProps> = ({ content }) => {
  return (
    <List>
      {content?.keyResponsibilities.slice(0, 2).map((responsibility, i) => (
        <Item key={'kr-' + i}>{responsibility}</Item>
      ))}
    </List>
  );
};

const List = styled.ul`
  color: ${xdlColorTextSecondary};
  line-height: ${scale110};
  padding-inline-start: ${spaceL};
  margin-bottom: ${spaceXS};
  margin-top: ${spaceS};
`;

const Item = styled.li`
  list-style-type: disc;
  line-height: ${scale110};
`;
